module.exports = __webpack_public_path__ + "static/media/ulip.610bb2e1.mp3";